<template>
    <p v-if="companyConfig[configKey]"
       class="help-block">
        <template v-if="showValue">
            If left blank, the company-wide value of
            <span class="label label-default">{{ companyConfig[configKey] }}</span>
            will be used.
        </template>
        <template v-else>
            If left blank, the existing company-wide value will be used.
        </template>
    </p>
</template>

<script>
export default {
    name: 'PaymentConfigDefaultValue',

    props: {
        deviceConfig: {
            type: Object,
            required: true,
        },
        companyConfig: {
            type: Object,
            required: true,
        },
        configKey: {
            type: String,
            required: true,
        },
        showValue: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
